import type { ReactElement } from 'react';

// Brand marks as inline SVGs (no extra request, CSP-safe, keep brand colors).

export const ZoomIcon = (): ReactElement => (
  <svg width='24' height='16' viewBox='0 0 28 20' aria-label='Zoom' style={{ display: 'block' }}>
    <rect width='28' height='20' rx='5' fill='#2d8cff' />
    <path
      d='M6 8c0-.9.7-1.6 1.6-1.6h7.2c.9 0 1.6.7 1.6 1.6v4c0 .9-.7 1.6-1.6 1.6H7.6C6.7 13.6 6 12.9 6 12zM17.4 9.1l3.9-2.3c.5-.3 1.1.07 1.1.64v5.12c0 .57-.6.94-1.1.64l-3.9-2.3z'
      fill='#fff'
    />
  </svg>
);

export const YouTubeIcon = (): ReactElement => (
  <svg width='24' height='16' viewBox='0 0 28 20' aria-label='YouTube' style={{ display: 'block' }}>
    <rect width='28' height='20' rx='5' fill='#ff0000' />
    <path d='M11 5.4L19.6 10 11 14.6Z' fill='#fff' />
  </svg>
);

export const FacebookIcon = (): ReactElement => (
  <svg width='16' height='16' viewBox='0 0 20 20' aria-label='Facebook' style={{ display: 'block' }}>
    <rect width='20' height='20' rx='4' fill='#1877f2' />
    <path
      d='M11.7 20v-6.9h2.06l.39-2.69H11.7V8.27c0-.78.24-1.31 1.4-1.31h1.49V4.55a20.6 20.6 0 0 0-2.18-.11c-2.16 0-3.63 1.27-3.63 3.62v2.04H6.6v2.69h2.18V20z'
      fill='#fff'
    />
  </svg>
);
